export default __webpack_public_path__ + "3a8bef8e9311be67bb5b343e63c50ec0.svg";